import { render } from "./CreateCommission.vue?vue&type=template&id=5d4dec0e&scoped=true"
import script from "./CreateCommission.vue?vue&type=script&lang=js"
export * from "./CreateCommission.vue?vue&type=script&lang=js"

import "./CreateCommission.vue?vue&type=style&index=0&id=5d4dec0e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4dec0e"]])

export default __exports__